import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import EditIcon from '@material-ui/icons/Edit'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import HelpIcon from '@material-ui/icons/Help'
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon'
import clsx from 'clsx'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useEditMode } from '../../providers/EditMode'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    speedDial: {
      '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
        position: 'fixed',
        bottom: '50%',
        right: theme.spacing(2)
      }
    },
    speedDialAction: {},
    speedDialActionActive: {
      '&.MuiSpeedDialAction-fab': {
        backgroundColor: theme.palette.primary.light,
        color: 'white'
      }
    }
  })
)

interface FloatingMenuProps {
  handleDrawing(state: boolean): void
}

export const FloatingMenu: React.FC<FloatingMenuProps> = ({
  handleDrawing
}) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const [active, setActive] = React.useState<string>('')

  const { editMode } = useEditMode()

  const router = useHistory()
  const location = useLocation()

  const actions = [
    { icon: <EditIcon />, name: 'Desenhar' },
    { icon: <HelpIcon />, name: 'Ajuda' }
  ]

  const editModeActions = [{ icon: <FileCopyIcon />, name: 'Copiar' }]

  const handleHelp = (name: string) => {
    // TO-DO OPEN MODAL WITH ACTUAL LOCATION PAGE
    router.push(`/nav/ajuda/${name}`)
  }

  const handleActive = (name: string) => {
    switch (name) {
      case 'Desenhar':
        handleDrawing(true)
        break
      case 'Ajuda':
        if (active === name) {
          router.goBack()
        } else {
          handleHelp(location.pathname.substring(5))
        }
        handleDrawing(false)
        break
      case 'Copiar':
        {
          const [navigation, item, slug] = location.pathname
            .substring(1)
            .split('/')
          router.push(`/${navigation}/${item}/${slug}/copiar`)
          return
        }
        break
      default:
        handleDrawing(false)
    }

    if (active === name) {
      handleDrawing(false)
      setActive('')
    } else {
      setActive(name)
    }

    setOpen(false)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  React.useEffect(() => {
    if (location.pathname === '/nav/ajuda' && active === 'Ajuda') {
      return undefined
    } else {
      setActive('')
    }
    handleDrawing(false)
  }, [location.pathname])

  if (location.pathname === '/nav/orcamento') return null

  return (
    <>
      <SpeedDial
        ariaLabel="Opções Flutuantes"
        className={classes.speedDial}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        direction="up"
      >
        {actions.map(action => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            className={clsx(classes.speedDialAction, {
              [classes.speedDialActionActive]: active === action.name
            })}
            tooltipTitle={action.name}
            onClick={() => handleActive(action.name)}
          />
        ))}
        {editMode &&
          editModeActions.map(editAction => (
            <SpeedDialAction
              key={editAction.name}
              icon={editAction.icon}
              className={clsx(classes.speedDialAction, {
                [classes.speedDialActionActive]: active === editAction.name
              })}
              tooltipTitle={editAction.name}
              onClick={() => handleActive(editAction.name)}
            />
          ))}
      </SpeedDial>
    </>
  )
}

export default FloatingMenu
